export async function submitHubspotForm({ formId, submitBody, pageData }) {
  //   const xhr = new XMLHttpRequest();
  const url = `https://api.hsforms.com/submissions/v3/integration/secure/submit/${process.env.HUBSPOT_PORTAL_ID}/${formId}`;

  const formData = {
    submittedAt: Date.now(),
    fields: submitBody,
    context: {
      ...pageData,
    },
    legalConsentOptions: {
      // Include this object when GDPR options are enabled
      consent: {
        consentToProcess: true,
        text: "Freely given consent from contact, Legitimate interest – prospect/lead",
        communications: [
          {
            value: true,
            subscriptionTypeId: 999,
            text: "I agree to receive marketing communications from WhereNext.to.",
          },
        ],
      },
    },
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.HUBSPOT_PRIVATE_APP_KEY}`,
    },
    body: JSON.stringify(formData),
  });

  const data = await response.json();

  return data;
}

export async function processHubspotForm({ formId, formValues, pageData }) {
  try {
    const submitBody = Object.entries(formValues).map((entry) => {
      const object = { objectTypeId: "0-1", name: entry[0], value: entry[1] };

      if ((entry[0] === "phone" && !entry[1]) || entry[1] == null) {
        object.value = "";
      }

      return object;
    });

    const response = await fetch("/api/external/hubspot/form-submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        formId,
        submitBody,
        pageData,
      }),
    });

    const data = await response.json();

    if (data?.status === "error") {
      throw new Error(JSON.stringify({ ...data }));
    }

    return data;
  } catch (error) {
    return { status: "error", message: JSON.parse(error.message).message };
  }
}
